import reducer from './dynamic-message-reducer';

export default reducer;
export { initialState } from './dynamic-message-reducer';
export * from './dynamic-message-actions';
